import { Component, OnInit, OnDestroy } from '@angular/core';
import { ValidatorService } from '../../../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '../../../../utils';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-validators-config-view',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css']
})

export class ValidatorsConfigViewComponent implements OnInit, OnDestroy {

    sub: any;
    limit = 12;

    validationConfiguration: any = {
        items: [],
        idValidationProvider: null,
        name: '',
        description: '',
        intervalValue: '',
        intervalUnit: 'm'
    };
    tariffs = [];
    validationTypes = [
        { value: 0, label: 'Upust czasowy [minuty]' },
        { value: 1, label: 'Upust [PLN]' },
        { value: 2, label: 'Upust procentowy [%]' },
        { value: 4, label: 'Zmiana taryfy' },
        { value: 5, label: 'Dodatkowa opłata [PLN]' },
        { value: 6, label: 'Dodatkowa opłata [%]' },
        { value: 7, label: 'Zapłacono do' },
    ];
    intervalUnits = [
        { value: 'm', label: 'minuty' },
        { value: 'h', label: 'godziny' },
        { value: 'd', label: 'dni' }
    ];

    constructor(
        private route: ActivatedRoute,
        private validatorService: ValidatorService,
        private utils: Utils,
        private messageService: MessageService,
        private router: Router) { }

    ngOnInit() {
        this.sub = this.route.parent.params.subscribe(parentParams => {
            this.validationConfiguration.idValidationProvider = parentParams['id'];
            this.route.params.subscribe(params => {
                let idConfig = params['id'];
                if (!idConfig || idConfig == 'new') {
                    localStorage.removeItem('currentValidationConfiguration');
                }
                else {
                    let tmpVC = localStorage.getItem('currentValidationConfiguration');
                    if (tmpVC) {
                        this.validationConfiguration = JSON.parse(tmpVC);
                    }
                }
                this.validatorService.getAllTariffs().subscribe(
                    tariffs => {
                        this.tariffs = tariffs.map(tariff => { return { value: tariff.idTariff, label: tariff.tariffName }; });
                        console.log(this.tariffs);
                    }
                );
                console.log(this.validationConfiguration);
            });
        });
    }

    addItem() {
        console.log('addItem', this.validationConfiguration.items);
        if (!this.validationConfiguration.items) {
            this.validationConfiguration.items = [];
        }
        let item = {
            id: null,
            order: null,
            validationType: 0,
            validationValue: null,
            validationValueIntervalUnit: null
        };
        this.validationConfiguration.items = this.validationConfiguration.items.concat([item]);
        console.log('addItem', this.validationConfiguration.items);
    }

    delItem(itemIndex) {
        this.validationConfiguration.items.splice(itemIndex, 1);
        this.validationConfiguration.items = [...this.validationConfiguration.items];
    }

    save(): void {
        console.log(this.validationConfiguration);
        this.validatorService.saveValidationConfiguration(this.validationConfiguration)
            .subscribe(
                validationConfiguration => {
                    this.messageService.add({ severity: 'success', summary: 'Zapisano konfigurację walidacji' });
                    this.validationConfiguration = validationConfiguration;
                    this.router.navigate(['../'], { relativeTo: this.route });
                },
                error => {
                    this.messageService.add({ severity: 'error', summary: 'Wystąpił błąd podczas zapisu konfiguracji walidacji', detail: this.utils.handleError(error) });
                }
            );
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
